import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { computed } from 'mobx';
import { Model } from 'core/model/Model';
let AssetTagInventoryModel = (_class = class AssetTagInventoryModel extends Model {
  get isNewValue() {
    return this.get('value') === '';
  }
  get valueEdited() {
    return !this.isNewValue && this.get('value') !== this.get('target_value');
  }
  get valueUnchanged() {
    return !this.isNewValue && !this.valueEdited;
  }
  get hasError() {
    return this.get('target_value') === '';
  }
  get canSave() {
    return !this.hasError && (this.isNewValue || this.valueEdited);
  }
}, _applyDecoratedDescriptor(_class.prototype, "isNewValue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNewValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "valueEdited", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "valueEdited"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "valueUnchanged", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "valueUnchanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canSave", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canSave"), _class.prototype), _class);
export { AssetTagInventoryModel as default };